import React, { ReactNode } from "react";
import { connect } from "react-redux";
import { session } from "apex-legit-service";
import { RootAction, RootState } from "StoreTypes";
import { bindActionCreators, Dispatch as reduxDispatch } from "redux";
import { removeToken, setToken } from "../../services/legit/token";

export interface Props {
  token: string;
  addToken: (token: string) => void;
  children: ReactNode;
}

const localStorageName = "token";

function APITokenPersistence({ token, children, addToken }: Props) {
  if (token !== undefined && token !== "") {
    localStorage.setItem(localStorageName, token);
    addToken(token);
    // call an action to set this in redux and then we'll use that instead of token
  } else {
    const localToken = localStorage.getItem(localStorageName);
    if (localToken !== null) {
      addToken(localToken);
    }
  }
  return <>{children}</>;
}

function removeApiToken() {
  localStorage.removeItem(localStorageName);
  // call an action to clear it in redux as well. This is our 'logout' flow
  removeToken();
}

const mapStateToProps = (state: RootState) => ({
  token: session.selectToken(state),
});

const mapDispatchToProps = (dispatch: reduxDispatch<RootAction>) =>
  bindActionCreators(
    {
      addToken: (token: string) => setToken(token),
    },
    dispatch
  );

export { removeApiToken };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(APITokenPersistence);
